<template>
  <div class="login-view">
    <LoginRegisterForm
      @login="$router.push('/')"
      :registerView="register"
      :verification="verificationMessage"
      :verificationSuccess="verificationSuccess"
    />
  </div>
</template>
<script>
import LoginRegisterForm from "@/components/form/LoginRegisterForm.vue";
export default {
  components: { LoginRegisterForm },
  props: {
    register: { default: false },
    verification: { default: false },
    verificationSuccess: { default: false }
  },
  computed: {
    verificationMessage: function() {
      if (this.verification) {
        if (this.verificationSuccess) {
          return "Adresse email validée avec succès";
        } else {
          return "L'adresse email n'a pas pu être validé...";
        }
      }
      return null;
    }
  },
  created() {}
};
</script>
<style lang="scss">
.login-view {
  max-width: 500px;
  margin: 20px auto;
  text-align: center;
}
</style>
